import React, { useEffect, useState } from "react"
import { Container, Header, Body, SearchContainer, Select, Input, Result, Title, Grid, CardContainer, Info, Image, Rating, Name, Thumb, Date } from "./styles/popup"
import { Container as MainContainer } from "../../containers"
import { Icon } from "../../components"
import Color from "../../constants/Color"

export default function Popup({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>
}

Popup.Header = function PopupHeader({ children, ...rest }) {
  return (
    <Header {...rest}>
      <MainContainer>
        <SearchContainer>{children}</SearchContainer>
      </MainContainer>
    </Header>
  )
}

Popup.Select = function PopupSelect({ children, ...rest }) {
  return (
    <Select id="by" name="by" {...rest}>
      {children}
    </Select>
  )
}

Popup.Input = function PopupInput({ children, ...rest }) {
  return <Input autoFocus placeholder="Search" {...rest} />
}

Popup.Body = function PopupBody({ children, title, prev, isLoading, ...rest }) {
  return (
    <Body {...rest}>
      <MainContainer>
        {title ? <Title>Search Result</Title> : ""}
        {prev && !isLoading && !title ? <Title>Previus Result</Title> : ""}
        {isLoading ? <Title>Searching....</Title> : ""}
        <Result>
          <Grid>{children}</Grid>
        </Result>
      </MainContainer>
    </Body>
  )
}

Popup.Result = function PopupResult({ children, ...rest }) {
  return <Result {...rest}>{children}</Result>
}

Popup.Title = function PopupTitle({ children, ...rest }) {
  return <Title {...rest}>{children}</Title>
}

Popup.Grid = function PopupGrid({ children, ...rest }) {
  return <Grid {...rest}>{children}</Grid>
}

Popup.MovieCard = function MovieCard({ children, to, rest }) {
  return (
    <CardContainer to={to} {...rest}>
      {children}
    </CardContainer>
  )
}

Popup.Thumb = function MovieCardThumb({ children, rate, rest }) {
  const [color, setColor] = useState("")
  let number = parseInt(rate)
  useEffect(() => {
    if (number < 4) {
      setColor((prev) => Color.bad)
    } else if (number > 3.9 && number < 7) {
      setColor((prev) => Color.ok)
    } else if (number > 6.9 && number < 8) {
      setColor((prev) => Color.great)
    } else if (number > 7.9) {
      setColor((prev) => Color.superb)
    }
  }, [number])
  return (
    <Thumb {...rest} color={color}>
      {children}
    </Thumb>
  )
}
Popup.Rating = function MovieCardRating({ rate, count, rest }) {
  const [color, setColor] = useState("")
  const [bgColor, setBgColor] = useState()
  let number = parseInt(rate)
  useEffect(() => {
    if (rate && number < 4) {
      setColor((prev) => Color.bad)
      setBgColor(Color.badBg)
    } else if (number > 3.9 && number < 7) {
      setColor((prev) => Color.ok)
      setBgColor(Color.okBg)
    } else if (number > 6.9 && number < 8) {
      setColor((prev) => Color.great)
      setBgColor(Color.greatBg)
    } else if (number > 7.9) {
      setColor((prev) => Color.superb)
      setBgColor(Color.superbBg)
    } else {
      setColor(Color.white)
    }
    // eslint-disable-next-line
  }, [number])

  return (
    <Rating {...rest} bg={bgColor} count={count} color={color}>
      {count ? "" : <Icon name="ph-star-fill" pt="1" mr="4" color={color} />}
      <p>{rate || count}</p>
    </Rating>
  )
}

Popup.Image = function MovieCardImage({ path, rest }) {
  return <Image src={path} {...rest} />
}

Popup.Info = function MovieCardInfo({ children, isTv, rest }) {
  return (
    <Info {...rest} isTv={isTv}>
      {children}
    </Info>
  )
}

Popup.Name = function MovieCardTitle({ children, rest }) {
  return <Name {...rest}>{children}</Name>
}

Popup.Date = function MovieCardDate({ children, rest }) {
  return <Date {...rest}>{children}</Date>
}
